import { AuthLayout, CompanySignUpForm } from 'features';
import { safiLogo } from 'features/brand';
import { useTranslation } from 'i18n';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Link, Typography } from 'ui';

import { getAuthRoute } from '../../utils/getAuthRoute';

export const SignUpCompany = () => {
  const { t } = useTranslation('auth');
  const { t: tCommon } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <AuthLayout
      title={t('shared.marketingTitle')}
      subtitle={t('shared.marketingSubtitle', { values: { brandName: tCommon('brand.name') } })}
      logo={safiLogo}
    >
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        {t('signUpCompany.title')}
      </Typography>
      <Typography>{t('signUpCompany.description')}</Typography>
      <CompanySignUpForm onSuccess={() => navigate(getAuthRoute('/sign-up/success'))} />
      <Link component={RouterLink} to={getAuthRoute('/sign-up/verify')}>
        {t('shared.goBack')}
      </Link>
    </AuthLayout>
  );
};
